import { Container } from "./style.js";
import { useAuth } from "../../contexts/AuthContext";
import logo from "../../assets/logos/3x-logo.png";

import { useNavigate, useLocation } from "react-router-dom";

const MinimalTopNav = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();
  return (
    <Container>
      <div className="logo">
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            navigate("/dashboard/on_demand_coach");
          }}
        >
          <img src={logo} alt="GuruNow" />
        </a>
      </div>
      <div className="utils">
        <ul>
          <li>
            <button onClick={() => navigate("/user/settings")}>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clip-path="url(#clip0_23_29)">
                  <path
                    d="M9.99996 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 9.99996 7.5C8.61925 7.5 7.49996 8.61929 7.49996 10C7.49996 11.3807 8.61925 12.5 9.99996 12.5Z"
                    stroke="#FEFEFE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M15.606 12.2727C15.5052 12.5012 15.4751 12.7547 15.5197 13.0004C15.5642 13.2462 15.6814 13.473 15.856 13.6515L15.9015 13.697C16.0423 13.8377 16.1541 14.0048 16.2304 14.1887C16.3066 14.3727 16.3458 14.5698 16.3458 14.7689C16.3458 14.9681 16.3066 15.1652 16.2304 15.3492C16.1541 15.5331 16.0423 15.7002 15.9015 15.8409C15.7608 15.9818 15.5937 16.0935 15.4097 16.1698C15.2258 16.246 15.0286 16.2853 14.8295 16.2853C14.6304 16.2853 14.4332 16.246 14.2493 16.1698C14.0654 16.0935 13.8983 15.9818 13.7575 15.8409L13.7121 15.7955C13.5335 15.6208 13.3068 15.5036 13.061 15.4591C12.8153 15.4145 12.5618 15.4446 12.3333 15.5455C12.1092 15.6415 11.9181 15.8009 11.7835 16.0042C11.6489 16.2074 11.5767 16.4456 11.5757 16.6894V16.8182C11.5757 17.22 11.4161 17.6054 11.1319 17.8896C10.8478 18.1737 10.4624 18.3333 10.0606 18.3333C9.65872 18.3333 9.27334 18.1737 8.98919 17.8896C8.70505 17.6054 8.54541 17.22 8.54541 16.8182V16.75C8.53955 16.4992 8.45838 16.2561 8.31247 16.052C8.16655 15.848 7.96264 15.6926 7.72723 15.6061C7.49874 15.5052 7.24527 15.4751 6.99951 15.5197C6.75376 15.5643 6.52699 15.6814 6.34844 15.8561L6.30299 15.9015C6.16227 16.0424 5.99517 16.1541 5.81123 16.2304C5.6273 16.3066 5.43013 16.3459 5.23102 16.3459C5.03191 16.3459 4.83474 16.3066 4.65081 16.2304C4.46687 16.1541 4.29977 16.0424 4.15905 15.9015C4.01818 15.7608 3.90642 15.5937 3.83017 15.4098C3.75392 15.2258 3.71468 15.0287 3.71468 14.8295C3.71468 14.6304 3.75392 14.4333 3.83017 14.2493C3.90642 14.0654 4.01818 13.8983 4.15905 13.7576L4.2045 13.7121C4.37915 13.5336 4.49631 13.3068 4.54087 13.061C4.58543 12.8153 4.55535 12.5618 4.4545 12.3333C4.35847 12.1093 4.19902 11.9182 3.99577 11.7836C3.79252 11.649 3.55434 11.5767 3.31057 11.5758H3.18178C2.77993 11.5758 2.39455 11.4161 2.1104 11.132C1.82626 10.8478 1.66663 10.4624 1.66663 10.0606C1.66663 9.65876 1.82626 9.27338 2.1104 8.98923C2.39455 8.70508 2.77993 8.54545 3.18178 8.54545H3.24996C3.50071 8.53959 3.7439 8.45842 3.94791 8.31251C4.15192 8.16659 4.30732 7.96268 4.3939 7.72727C4.49474 7.49877 4.52483 7.24531 4.48027 6.99955C4.43571 6.7538 4.31855 6.52703 4.1439 6.34848L4.09844 6.30303C3.95757 6.16231 3.84581 5.99521 3.76957 5.81127C3.69332 5.62733 3.65407 5.43017 3.65407 5.23106C3.65407 5.03194 3.69332 4.83478 3.76957 4.65085C3.84581 4.46691 3.95757 4.29981 4.09844 4.15909C4.23916 4.01821 4.40626 3.90646 4.5902 3.83021C4.77414 3.75396 4.9713 3.71471 5.17041 3.71471C5.36953 3.71471 5.56669 3.75396 5.75063 3.83021C5.93456 3.90646 6.10167 4.01821 6.24238 4.15909L6.28784 4.20454C6.46638 4.37919 6.69315 4.49635 6.93891 4.54091C7.18466 4.58547 7.43813 4.55539 7.66663 4.45454H7.72723C7.9513 4.35851 8.1424 4.19905 8.277 3.9958C8.4116 3.79255 8.48384 3.55438 8.48481 3.3106V3.18182C8.48481 2.77997 8.64444 2.39459 8.92859 2.11044C9.21273 1.8263 9.59812 1.66666 9.99996 1.66666C10.4018 1.66666 10.7872 1.8263 11.0713 2.11044C11.3555 2.39459 11.5151 2.77997 11.5151 3.18182V3.25C11.5161 3.49378 11.5883 3.73195 11.7229 3.9352C11.8575 4.13845 12.0486 4.2979 12.2727 4.39394C12.5012 4.49478 12.7547 4.52486 13.0004 4.4803C13.2462 4.43574 13.4729 4.31859 13.6515 4.14394L13.6969 4.09848C13.8376 3.95761 14.0048 3.84585 14.1887 3.7696C14.3726 3.69336 14.5698 3.65411 14.7689 3.65411C14.968 3.65411 15.1652 3.69336 15.3491 3.7696C15.533 3.84585 15.7002 3.95761 15.8409 4.09848C15.9817 4.2392 16.0935 4.4063 16.1697 4.59024C16.246 4.77418 16.2852 4.97134 16.2852 5.17045C16.2852 5.36957 16.246 5.56673 16.1697 5.75066C16.0935 5.9346 15.9817 6.1017 15.8409 6.24242L15.7954 6.28788C15.6208 6.46642 15.5036 6.69319 15.459 6.93895C15.4145 7.1847 15.4446 7.43817 15.5454 7.66666V7.72727C15.6414 7.95134 15.8009 8.14243 16.0042 8.27704C16.2074 8.41164 16.4456 8.48387 16.6894 8.48485H16.8181C17.22 8.48485 17.6054 8.64448 17.8895 8.92862C18.1737 9.21277 18.3333 9.59815 18.3333 10C18.3333 10.4018 18.1737 10.7872 17.8895 11.0714C17.6054 11.3555 17.22 11.5151 16.8181 11.5151H16.75C16.5062 11.5161 16.268 11.5884 16.0648 11.723C15.8615 11.8576 15.7021 12.0487 15.606 12.2727Z"
                    stroke="#FEFEFE"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_23_29">
                    <rect width="20" height="20" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </li>
          <li>
            <button
              onClick={() => {    
                logout();
                navigate("/login");
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M16.6667 17.5C16.6667 16.337 16.6667 15.7555 16.5232 15.2824C16.2 14.217 15.3663 13.3834 14.301 13.0602C13.8278 12.9167 13.2463 12.9167 12.0834 12.9167H7.91671C6.75374 12.9167 6.17225 12.9167 5.69909 13.0602C4.63375 13.3834 3.80007 14.217 3.47691 15.2824C3.33337 15.7555 3.33337 16.337 3.33337 17.5M13.75 6.25C13.75 8.32107 12.0711 10 10 10C7.92897 10 6.25004 8.32107 6.25004 6.25C6.25004 4.17893 7.92897 2.5 10 2.5C12.0711 2.5 13.75 4.17893 13.75 6.25Z"
                  stroke="#FEFEFE"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </li>
        </ul>
      </div>
    </Container>
  );
};

export default MinimalTopNav;
